// extracted by mini-css-extract-plugin
export default {"student-list-card":"StudentListBox_student-list-card__dvVvu"};